// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__20HW1","calendarButtons":"ClockData_calendarButtons__3A8LL"};